/**
 * Summary. Promotions Logic
 *
 * Description.
 * 1. Checks to see if cart form is on the page, if it is, it creates a new instance of Promotion and passes through the form
 * 2. Constructor to set up variables and to kickstart the bindings and inital functions
 * 3. Handle Form submit, pass the note and code to checkout if there is one else just go to the checkout
 * 4. Add upsell if threshold is met, listen for changes in cart total and remove if below threshold
 * 5. Listeners for cart total and cart item number changes
 * 6. Get products from schema for free gift and return them with null and undefined stripped out
 * 7. Auto free gift if threshold met, works from highest to lowest to apply the correct ones and listens for gift type, tiered or stacked
 * 8. Add gift, checks code entered against ones antered in the back end from comma sepeartaed list, built in static-cart-gift-with-purchase.liquid
 * 9. Global add and remove functions using axios to pass mutliple items to the cart
 * 10. Remove gift, check to see if the cart total is less than the min spend
 */
class PromotionsController {
  constructor() {
    const elements = document.querySelectorAll('.js-cart-form');
    // Check to see if the the cart form is on the page if it is invoke a new instance of Promotion class
    if (elements.length > 0) {
      elements.forEach(element => new Promotion(element));
    }
  }
}
class Promotion {
  constructor(element) {
    // General selectors
    this.element = element;

    this.discountObject = discountHash;
    this.allowStacking = giftWithPurchaseSettings.allow_stacking;

    this.discountCodePromotions = Object.entries(discountHash)
      .reduce((discounts, [code, data]) => ({
        ...discounts,
        [code]: {
          minimumSpend: data.minimumSpend,
          variantIds: Object
            .entries(data)
            .reduce((variantIds, [key, value]) => key.includes('product_') && !!value ? [...variantIds, value] : variantIds, [])
        }
      }), {});

    /* This turns the object from theme settings into an array of objects (one for each tier)
    * that look like this: { variantIds: [], amount: 10 }
    * where variantIds is an array of variant IDs the tier should add and amount is a number representing
    * the threshold amount for the tier, this is used by the autoFreeGift function to add/remove the correct items
    */
    this.autoFreeGiftThresholds = Object.entries(autoFreeGiftsObject)
      .reverse()
      .map(([amount, properties]) => {
        return {
          amount,
          variantIds: Object.entries(properties).reduce((allProperies, [key, value]) =>
            !!value && key.indexOf('free_gift') === 0 ? [...allProperies, value] : allProperies, [])
        };
      });

    this.autoFreeGiftTypeStacked = this.element.dataset.autoFreeGiftType === 'stacked';

    this.localCurrency = this.element.querySelector('[data-local-currency]');

    this.cartObject = document.querySelector('.js-cart-form');

    this.clearCartBtn = this.element.querySelector('#clear--cart');

    // Promo code selectors
    this.promoBtn = this.element.querySelector('#apply--promo');
    this.applyPromo = this.element.querySelector('#apply--promo');
    this.promoDifference = this.element.querySelector('#promo-difference');
    this.promoApplied = this.element.querySelector('#promo-applied');
    this.promoError = this.element.querySelector('#promo-error');
    this.freeGift = this.element.querySelectorAll('[data-free-gift]');

    // Upsell selectors
    this.sampleItem = this.element.querySelector('.sample-item');
    this.sampleItems = this.element.querySelectorAll('.sample-item');
    this.cartItemTotal = document.querySelector('.site-header-cart--count');
    this.productUpsell = this.element.querySelector('.collection-product--upsell');
    this.productUpsellOption = document.querySelectorAll('.productitem--action-atc');
    this.sampleItemsId = '';
    this.productUpsellThresholdLimit = [];
    this.productUpsellLimit = [];
    this.productUpsellThreshold = [];
    this.currentUpsellLimit = '';
    this.currentUpsellThreshold = '';
    this.upSellDifference = this.element.querySelector('.collection-product--upsell-spend');
    this.upSellDifferenceTotal = document.querySelector('.collection-product--upsell-spend .upsell-difference span');
    this.cart = document.querySelector('.cart-subtotal .money');
    this.cartTotal = '';
    this.flkty = '';
    this.options = {
      "cellAlign": "left",
      "pageDots": false,
      "setGallerySize": false,
      "cellSelector": ".productgrid--item",
      "wrapAround": true
    };
    this.samplesThresholds = Object.entries(samplesObject)
      .reverse()
      .map(([tier, properties]) => {
        this.productUpsellThresholdLimit.push([properties.samples_threshold, properties.samples_limit])
      });

    this.onLoad();
    this.bindEvents();
    this.upsellCarousel();
    this.addUpsell();
    this.removeGift();
    this.autoFreeGift();
  }

  onLoad() {
    if (!this.cart) {
      return
    }

    this.cartTotal = document.querySelector('.cart-subtotal .money').dataset.cartTotal;

    this.productUpsellThresholdLimit = this.productUpsellThresholdLimit.sort((a, b) => b[0] - a[0])


    if (this.productUpsell) {
      this.sampleItemsId = this.productUpsell.querySelectorAll('[data-id]');

      for (let i = 0; i < this.productUpsellThresholdLimit.length; i++) {
        let threshold = parseInt(this.productUpsellThresholdLimit[i][0])
        let limit = parseInt(this.productUpsellThresholdLimit[i][1])

        this.productUpsellThreshold.push(threshold)
        this.productUpsellLimit.push(limit)
      }

      for (let i = 0; i < this.productUpsellThresholdLimit.length; i++) {
        let threshold = parseInt(this.productUpsellThresholdLimit[i][0])
        let limit = parseInt(this.productUpsellThresholdLimit[i][1])

        if (parseInt(this.cartTotal) >= (threshold * 100)) {
          this.currentUpsellLimit = limit
          this.currentUpsellThreshold = threshold
          this.productUpsell.dataset.currentUpsellLimit = limit
          this.productUpsell.dataset.currentUpsellThreshold = threshold

          break
        }
      }
    }
  }

  async bindEvents() {
    const cartState = await Shopify.theme.cart.getState();

    if (this.cartObject) {
      this.cartObject.classList.remove("disable-checkout");
    }

    if (cartState.items.length === 0) return;

    // Form submit
    this.element.addEventListener('submit', this.handleFormSubmit.bind(this), false);
    // Promo button click
    this.promoBtn.addEventListener('click', this.addGift.bind(this), false);
    // Clear cart click
    this.clearCartBtn.addEventListener('click', this.clearCart.bind(this), false);

    // listen for upsell add
    this.productUpsellOption.forEach(element => {
      element.addEventListener('click', e => {
        this.cartObject.classList.add("disable-checkout");

        const id = parseInt(e.currentTarget.getAttribute('data-variant-id'));
        axios.post('/cart/add.js', { items: [{ id, quantity: 1 }] }).then(function (response) {
          window.location.reload(true);
        })
          .catch(function (error) {
            //console.log(error);
          });
      });
    });

    const cartTotalItemsObserver = new MutationObserver(this.cartTotalItemsCallback.bind(this));
    cartTotalItemsObserver.observe(this.cartItemTotal, {
      attributes: true,
      childList: true,
      subtree: true
    });

    // listen for cart value changes 
    const cartTotalObserver = new MutationObserver(this.cartTotalCallback.bind(this));
    cartTotalObserver.observe(this.cartItemTotal, {
      attributes: true,
      childList: true,
      subtree: true
    });

    const bundlerObserver = new MutationObserver(this.bundlerObserverCallback.bind(this));
    bundlerObserver.observe(this.cartItemTotal, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }


  handleFormSubmit(event) {
    event.preventDefault();

    const code = this.element.querySelector('[data-cart-discount-code]').value.toUpperCase();
    const note = this.element.querySelector('.js-cart-note').value;

    this.checkout(code, note);
  }

  async addUpsell() {
    const cartState = await Shopify.theme.cart.getState();
    const samplesInCart = cartState.items.filter(item => item.product_type === 'sample')

    if (!this.productUpsellOption || !this.productUpsell) {
      return;
    }

    if (this.cartTotal >= this.currentUpsellThreshold && this.currentUpsellLimit !== samplesInCart.length) {
      let flkty = Flickity.data('.productgrid--items');
      this.productUpsell.classList.remove("hide--upsell");
      this.upSellDifference.classList.remove("hide--upsell");

      if (flkty) {
        flkty.resize()
      }
    }

    if (this.productUpsellLimit[0] == this.currentUpsellLimit) {
      this.upSellDifference.classList.add("hide--upsell");
    }

    // Add class to products in sample selector that have already been added to cart
    samplesInCart.filter(sample => {
      this.sampleItemsId.forEach(item => {
        if (parseInt(item.dataset.id) === parseInt(sample.product_id)) {
          item.classList.add('sample-in-cart')
        }
      })
    })

    // Show samples if they are in cart
    for (const sample of this.sampleItems) sample.classList.remove("hide--upsell");

  }

  upsellCarousel() {
    if (!this.options) return

    this.flkty = new Flickity(document.querySelector('.productgrid--items'), this.options);

    if (window.screen.width > 760 && window.screen.width < 1023) {
      if (this.flkty.cells.length <= 3) {
        this.flkty.destroy()
      }
    }
  }

  bundlerObserverCallback(mutations, bundlerObserver) {
    if (this.cart.querySelector('[data-money-convertible]')) {
      this.cart = this.cart.querySelector('.bundlr-cart-values:not(".bundlr-cart-values-old-price")');
    }
  }

  // listen for item number changes 
  cartTotalItemsCallback(mutationsList, cartTotalItemsObserver) {
    this.cartItemTotal = document.querySelector('.site-header-cart--count');
    this.sampleItem = document.querySelector('.sample-item');

    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes') {

        if (this.cartItemTotal.dataset.headerCartCount < 1) {
          this.productUpsell.classList.add("hide--upsell");
          this.upSellDifference.classList.remove("hide--upsell");
        }

        if (parseInt(this.cartTotal) > parseInt(this.productUpsellThreshold)) {
          if (!this.sampleItem || this.sampleItem.classList.contains('removing')) {
            this.productUpsell.classList.remove("hide--upsell");
            this.upSellDifference.classList.add("hide--upsell");
          }
        }

      }
    }
  };

  async cartTotalCallback(mutationsList, cartTotalObserver) {
    this.freeGift = document.querySelectorAll('.cart-item[data-free-gift]');
    this.threshold = parseInt(this.productUpsellThreshold);
    this.cartUpdated = false;

    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        this.cartObject.classList.add("disable-checkout");
        if (this.cartTotal < this.threshold) {
          this.productUpsell.classList.add("hide--upsell");
          this.upSellDifference.classList.remove("hide--upsell");

          // work out the new difference and tell the customer
          this.newDifference = parseInt(this.productUpsellThreshold) - parseInt(this.cartTotal);
          this.upSellDifferenceTotal.innerHTML = Shopify.formatMoney(this.newDifference, this.localCurrency.dataset.localCurrency);

          if (this.sampleItem) {
            this.sampleItem.classList.add("hide--upsell");
            this.cartObject.classList.add("disable-checkout");
            this.cartUpdated = true;
          }
        }

        if (this.cartTotal > this.threshold) {
          if (!this.sampleItem) {
            this.productUpsell.classList.remove("hide--upsell");
            this.upSellDifference.classList.add("hide--upsell");
          }
        }

        if (this.cartTotal === 0) {
          if (this.freeGift) {
            this.cartObject.classList.add("disable-checkout")
            this.cartUpdated = true;
          }
        }

        this.cartUpdated = true;
      }
    }

    if (this.cartUpdated) window.location.reload(true);
  };

  async autoFreeGift() {
    const cartState = await Shopify.theme.cart.getState();
    const cartTotal = cartState.items.reduce((total, { line_price, properties }) => {
      return Object.keys(properties).find(key => key.startsWith('_threshold-'))
        ? total - line_price
        : total;
    }, cartState.total_price) / 100;


    // Quick fix to force 0 priced items to display as 0 in the basket
    // This can probably be done in a better way
    const lineItemPriceArr = document.querySelectorAll('[data-cartitem-total]');

    lineItemPriceArr.forEach(item => {
      if (item.dataset.cartitemTotal == 0) {
        item.innerHTML = item.innerHTML.replace(/[^$£€]*$/, '0.00')
      }
    })


    let thresholdSet = new Set();
    // This reducer returns an object which contains an add and remove array of variant IDs so that we can bulk add/remove at the end
    const updates = this.autoFreeGiftThresholds.reduce((allUpdates, { amount, variantIds }) => {
      // Check if the total is greater than the threshold and we're either in a stacked promotion or haven't applied a tier yet
      // if so add any items that aren't already in the cart to the add array            
      variantIds.filter(id => cartState.items.find(({ variant_id, properties }) => {
        if (id === variant_id && properties[`_threshold-${amount}-${id}`]) {
          thresholdSet.add(parseInt(Object.keys(properties).find(key => key.startsWith('_free-')).replace('_free-', '')))
        }
      }))

      let thresholds = Array.from(thresholdSet)

      if (cartTotal >= parseInt(amount) && (this.autoFreeGiftTypeStacked || !allUpdates.tierApplied)) {
        allUpdates.add.push(
          ...variantIds
            .filter(id => !cartState.items.find(({ variant_id, properties }) => id === variant_id && properties[`_threshold-${amount}-${id}`]))
            .map(id => ({ id, quantity: 1, properties: { [`_threshold-${amount}-${id}`]: 'true', [`_free-${amount}`]: 'true' } }))
        );
        allUpdates.tierApplied = true;
      }

      if (!this.autoFreeGiftTypeStacked) {
        if (thresholds.length > 1) {
          if (cartTotal > Math.min(...thresholds) && amount !== Math.min(...thresholds)) {
            allUpdates.remove.push(
              ...variantIds
                .filter(id => cartState.items.find(({ variant_id, properties }) => id === variant_id && properties[`_threshold-${Math.min(...thresholds)}-${id}`]))
            );
          }
        }
      }


      // If we aren't in the threshold, add any items that are in the cart that are part of this promotion to the remove array
      if (cartTotal < parseInt(amount)) {
        allUpdates.remove.push(
          ...variantIds
            .filter(id => cartState.items.find(({ variant_id, properties }) => id === variant_id && properties[`_threshold-${amount}-${id}`]))
        );
      }
      return allUpdates;
    }, { add: [], remove: [], tierApplied: false });


    if (updates.add.length === 0 && updates.remove.length === 0) return; // Nothing to update in the cart, just return early

    if (updates.add.length) {
      this.cartObject.classList.add("disable-checkout");
      await axios.post('/cart/add.js', { items: updates.add });
    }

    if (updates.remove.length) {
      this.cartObject.classList.add("disable-checkout");
      await axios.post('/cart/update.js', { updates: updates.remove.reduce((updateObject, id) => ({ ...updateObject, [id]: 0 }), {}) });
    }

    window.location.reload(true); // We've added/removed everything so reload to update the cart on page
  }


  // Gift With Purchase
  async addGift() {
    const cartState = await Shopify.theme.cart.getState();
    const cartTotal = cartState.total_price / 100;
    const code = this.element.querySelector('[data-cart-discount-code]').value.toUpperCase();
    const codeHash = md5(code);
    const promotion = this.discountCodePromotions[codeHash];

    if (promotion) {
      if (cartTotal >= promotion.minimumSpend) {
        if (!this.allowStacking) {
          if (cartState.items.some(item => item.properties.hasOwnProperty('promo') && item.product_type === 'free gift')) { return }
        }

        this.applyPromo.classList.add('processing');

        const itemsToAdd = promotion.variantIds
          .reduce((items, id) => !cartState.items.find(({ variant_id }) => id === variant_id)
            ? [...items, { id, quantity: 1, properties: { _discountPromotion: codeHash, 'promo': `FG-${code}` } }]
            : items,
            []);

        if (itemsToAdd.length) {
          this.msgStyles('none', 'block', 'none')
          await axios.post('/cart/add.js', { items: itemsToAdd });
          window.location.reload(true);
        }
      } else {
        this.promoText = this.element.querySelector('#promo-difference span').innerHTML = Shopify.formatMoney(promotion.minimumSpend * 100, this.localCurrency.dataset.localCurrency);
        this.promoDifference.querySelector('span').textContent = this.promoText;
        this.msgStyles('block', 'none', 'none')
      }
    } else {
      this.msgStyles('none', 'none', 'block')
    }

    this.applyPromo.classList.remove('processing');
  }

  msgStyles(diff, app, err) {
    this.promoDifference.style.display = diff;
    this.promoApplied.style.display = app;
    this.promoError.style.display = err;
  }

  async removeGift() {
    const cartState = await Shopify.theme.cart.getState();
    const cartTotal = cartState.total_price / 100;
    let sampleThreshold = '';
    let sampleLimit = '';
    const samplesInCart = [];


    if (this.productUpsell) {
      sampleThreshold = parseInt(this.productUpsell.dataset.currentUpsellThreshold) / 100;
      sampleLimit = this.productUpsell.dataset.currentUpsellLimit;
    }

    cartState.items.forEach(item => { if (item.product_type === 'sample') samplesInCart.push(item) })

    const updates = cartState.items.reduce((payload, { properties, variant_id, product_type }) => {
      // if sample and number of samples is higher than sample limit or total price is less than sample limit
      if (product_type === 'sample' && (cartTotal < sampleThreshold || samplesInCart.length > sampleLimit)) return { ...payload, [variant_id]: 0 }

      if (!properties._discountPromotion) return payload;

      const promotion = this.discountCodePromotions[properties._discountPromotion];

      if (!promotion || cartTotal < promotion.minimumSpend) return { ...payload, [variant_id]: 0 };
      return payload;
    }, {});

    if (Object.keys(updates).length === 0) return;

    this.cartObject.classList.add("disable-checkout");

    await axios.post('/cart/update.js', { updates });

    window.location.reload(true);
  }

  async clearCart() {
    this.cartObject.classList.add("disable-checkout");

    await axios.post('/cart/clear.js');

    window.location.reload(true);
  }

  checkout(discount, note) {
    const query = Object
      .entries({ discount, note })
      .reduce((queryString, [key, value]) => !!value ? `${queryString}${queryString.length ? '&' : '?'}${key}=${value}` : queryString, '');

    window.location.assign(`/checkout${query}`);
  }
}

//check facebook pixel function exists as well as eventName and contentName before tracking events
function callFbq(eventName, contentName) {
  if (typeof fbq === 'undefined' || typeof eventName === 'undefined' || typeof contentName === 'undefined') return;

  fbq('track', eventName, {
    content_name: contentName,
    content_category: '',
    content_ids: [''],
    content_type: '',
    value: 0,
    currency: ''
  });
}

//Call facebook pixel tracking with page load event and then register individual handlers
function initPixelTracking() {
  callFbq('ViewContent', 'Sephora Events Page Visited');

  $('#eventBtnGrey').on('click', function () {
    callFbq('EventButtonGrey', 'Sephora Events Page Event Button Grey');
  });

  $('#eventBtnWhite').on('click', function () {
    callFbq('EventButtonWhite', 'Sephora Events Page Event Button White');
  });

  $('#learnMore').on('click', function () {
    callFbq('LearnMore', 'Sephora Events Page Learn More Button');
  });

  $('.faqAccordion').on('click', function () {
    callFbq('FaqAccordion', 'Sephora Events Page Faq Accordion: ' + $(this).html());
  });

}

//Push data for Snapchat Pixel
function atcSnapchat() {
  let price = $('.price--main .money').text().replace('$', ''),
    variantID = $('.form-options :selected').attr('data-variant-id');
  snaptr('track', 'ADD_CART', {
    'currency': 'USD',
    'price': price,
    'item_ids': [variantID]
  });
  console.log('Snapchat Submission');
}

window.addEventListener('load', function () {
  new PromotionsController();

  var bodyElem = document.body;
  // If on US store and the page handle data attribute exists and it's the sephora events handle call initPixelTracking()...
  if (bodyElem.classList.contains('store-us') && bodyElem.dataset.pageHandle !== undefined && bodyElem.dataset.pageHandle === 'sephoraevents') initPixelTracking();
});

document.addEventListener("DOMContentLoaded", function () {
  $('.product-form--atc-button').on('click', function () {
    atcSnapchat();
  });

  if (!$('body').hasClass('template-product')) return;

  const mediaquery = window.matchMedia("(max-width: 570px)");
  const productDescription = document.getElementById('product-description');
  const formContainer = document.getElementById('product-form--regular');
  const productformArea = document.getElementById('data-product-form-area');
  const header = document.getElementById('site-header');

  function checkScroll() {
    if (mediaquery.matches) {
      let distanceToTop = productDescription.getBoundingClientRect().top;
      let formContainerHeight = formContainer.offsetHeight;
      let headerHeader = header.offsetHeight;
      if (distanceToTop < 0) {
        productformArea.classList.add('fixed-top');
        productformArea.style.top = headerHeader + 'px';
      } else {
        productformArea.classList.remove('fixed-top');
        productformArea.style.top = '0px';
      }
    } else {
      productformArea.classList.remove('fixed-top');
      formContainer.style.height = 'auto';
    }
  }
  function addToCartThrottle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  if (!productDescription || !formContainer || !productformArea || !header) return;
  document.addEventListener('scroll', addToCartThrottle(checkScroll, 1000));
});
